import moment from "moment";

const error = (errorKeyPrefix, field, errorType) => `${errorKeyPrefix}.invalid.${field}.${errorType}`;

export const validateRequired = ({ values, errors, field, errorKey }) => {
  const value = values[field];

  if (value == null || String(value).trim() === "") {
    errors[field] = error(errorKey, field, "required");
  }
};

export const validateMinLength = ({ values, errors, field, min, errorKey }) => {
  const value = values[field];

  if (value != null && String(value).trim().length < min) {
    errors[field] = error(errorKey, field, "minLength");
  }
};

export const validateMaxLength = ({ values, errors, field, max = 100, errorKey }) => {
  validateRequired({ values, errors, field, errorKey });
  const value = values[field];

  if (value != null && String(value).trim().length > max) {
    errors[field] = error(errorKey, field, "maxLength");
  }
};

export const validateMin = ({ values, errors, field, min = 0, errorKey }) => {
  validateRequired({ values, errors, field, errorKey });
  const value = values[field];

  if (value != null && value !== "" && Number(value) < min) {
    errors[field] = error(errorKey, field, "minValue");
  }
};

export const validateMax = ({ values, errors, field, max, errorKey }) => {
  validateRequired({ values, errors, field, errorKey });
  const value = values[field];

  if (value != null && value !== "" && Number(value) > max) {
    errors[field] = error(errorKey, field, "maxValue");
  }
};

export const validateNumberLimits = ({ values, errors, field, min = 0, max = 100, errorKey }) => {
  validateRequired({ values, errors, field, errorKey });
  validateMin({ values, errors, field, min, errorKey });
  validateMax({ values, errors, field, max, errorKey });
};

export const validateTime = ({ values, errors, field, errorKey }) => {
  validateRequired({ values, errors, field, errorKey });
  const value = values[field];

  if (!moment(value, ["HH:mm:ss", "HH:mm"], true).isValid()) {
    errors[field] = error(errorKey, field, "time.type");
  }
};

export const validatePeriod = ({ values, errors, startField, endField, errorKey }) => {
  const startMoment = moment(values[startField], ["HH:mm:ss", "HH:mm"], true);
  const endMoment = moment(values[endField], ["HH:mm:ss", "HH:mm"], true);

  if (!startMoment.isValid() || !endMoment.isValid()) {
    return;
  }

  if (!startMoment.isBefore(endMoment)) {
    errors[startField] = error(errorKey, startField, "time.period");
    errors[endField] = error(errorKey, endField, "time.period");
  }
};

export const validateRegex = ({ values, errors, field, regex, errorKey }) => {
  const value = values[field];

  if (value != null && value !== "" && !regex.test(String(value).trim())) {
    errors[field] = error(errorKey, field, "regex");
  }
};
